export * from "./getOptimizedMagentoImageUrl";
